import React, { Component } from 'react';
import CollapsablePanel from './CollapsePanel';
import Location from './Location';

function canAdd(nrOfLoc, plan) {
    return plan === 'professional';
}

class Locations extends Component {
    render() {
        let { fields, locations, dispatch, user, showLabels } = this.props;

        return <div>
            {fields.length === 0 && <i>Please add at least one location.</i>}
                    
                <br />
            {fields.map((location, idx) => {
                return <div key={idx}>
                    <CollapsablePanel location={'location' + idx} section={'location' + idx} title={`Location #${idx+1} - ${locations[idx].accounting.country}`}>
                        <Location dispatch={dispatch} showLabels={showLabels} location={locations[idx]} idx={idx} onClick={() => fields.remove(idx)} el={location} />
                    </CollapsablePanel>
                </div>
            })}
            <br />
            {canAdd(fields.length, user.profile.subscription) ?
                <button className="btn btn-sm btn-primary" style={{display: showLabels? 'none': 'block'}} title="Add a new location" onClick={() => fields.push({
                    accounting: {
                        country: 'US',

                    },
                    themes: [],
                    styles: {
                        logo: '',
                        headerColor: '#000000',
                        headerBackground: '#f7f4f4',
                        textColor: '#000000',
                        borderColor: '#000000',
                        thankYouText: 'Thank you for buying from us!',
                        paperSize: {
                            format: 'A4',
                            orientation: 'portrait',
                            margin: 0.8
                        }
                    },
                    taxes: {
                        override: false,
                        productsRate: 0.0,
                        shippingRate: 0.0,
                        taxesIncluded: true,
                        skuRate: 0.0,
                        skus: ''
                    },
                    currentInvoiceNumber: 0,
                    invoicePrefix: "Loc",                  
                    creditNotePrefix: "CNLoc",
                    currentCreditNoteNumber: 0,
                    decimalPlaces: 2,
                    showVTA: true
                })}><i className="widget-add-item fa fa-plus-circle" ></i>{""} Add a new location</button> : 'You need to upgrade your plan to add more locations'}    
        </div>
    }
}

export default Locations;



// WEBPACK FOOTER //
// app/containers/Locations.jsx